import {
  HowItWorksSteps,
  type HowItWorksStep,
} from 'features/producer-buyer-portal/shared/how-it-works-steps';

/**
 * One explainer panel per wizard step, in the same numbered panels the
 * Schedule section on a processor's landing page uses.
 *
 * Per step rather than all of them up front: a producer reading step three
 * needs to know what step three does, and a stack of every step on screen
 * one is a wall of text between them and the first control. The number is
 * the step's real position in the wizard, which is why it's passed in — the
 * processor-selection step only exists when a producer has more than one
 * processor, so nothing downstream has a fixed index.
 *
 * These are the words of the landing page's three beats, split apart and
 * expanded with what each screen actually asks for.
 */
export const STEP_INTRO_PROCESSOR: HowItWorksStep = {
  title: 'Pick your processor',
  body: 'The facilities you already work with. One job goes to one of them.',
};

export const STEP_INTRO_DETAILS: HowItWorksStep = {
  title: 'Say what you’re bringing',
  body: 'Species, how many head, and the inspection level you need. Open days are the ones with capacity left for that count — grey days can’t take it.',
};

export const STEP_INTRO_REVIEW: HowItWorksStep = {
  title: 'Check it over',
  body: 'Add your animals and any cut-sheet notes. Nothing is booked until the facility accepts the request.',
};

export const STEP_INTRO_DEPOSIT: HowItWorksStep = {
  title: 'Pay the deposit',
  body: 'This facility holds the date with a deposit. Your booking stays pending until it’s paid.',
};

/**
 * Render one step's panel.
 * @param root0 - Props.
 * @param root0.intro - The panel for this step.
 * @param root0.number - The step's position in the wizard, 1-based.
 * @returns The panel.
 */
export function StepIntro({
  intro,
  number,
}: {
  intro: HowItWorksStep;
  number: number;
}) {
  return <HowItWorksSteps steps={[intro]} numbered startNumber={number} />;
}
